<template>
<div class="classify-bar">
  <div class="classify">
    <div v-if="0" class="left-cover"></div>
    <van-tabs v-model="active">
      <van-tab title-style='' v-for="(catItem, index) in item.catList" :key='index'>
        <template v-if="active != index" #title>
          <img v-if="catItem.defaultImg" :src="catItem.defaultImg" />
          <span v-else :style="{'color':catItem.textColor}">{{catItem.columnCatName}}</span>
        </template>
        <template v-else #title>
          <img v-if="catItem.columnCatImg" :src="catItem.columnCatImg" />
          <span v-else :style="{'color':catItem.activeColor}">{{catItem.columnCatName}}</span>
        </template>
      </van-tab>
    </van-tabs>
  </div>
  <div class="category-line"></div>
  <div @click="toCategory" class="category-fixed">分类</div>
</div>
</template>

<script>
export default { 
  name: 'Classify',
  data() {
    return {
      active: 0,
    }
  },
  props: {
    item: Object,
  },
  components: {
  },
  created() {
  },
  mounted() {
  },
  watch: {
    active: function () {
      var self = this
      if (self.item.catList[self.active].columnCatUrl) {
        window.location.href = self.item.catList[self.active].columnCatUrl;
        return
      }
      var extPageId = self.item.catList[self.active].extPageId || '';
      var prodCategoryId = self.item.catList[self.active].prodCategoryId || '';
      self.active == 0 && (extPageId = '90005');
      this.$store.commit('setPageId',extPageId);
      this.$store.commit('setProdCategoryId',prodCategoryId);
      this.$store.dispatch('getAjaxBase',{pageId: extPageId})
      this.$store.commit('doTrack',{
        href: '#',
        columnDefineId: self.item.columnDefineId,
        ccId: self.item.catList[self.active].columnCatDefineId,
        adId: self.item.catList[self.active].columnCatId,
        adName: self.item.catList[self.active].columnCatName,
        idType: 'tabId'
      });
      $('.container').scrollTop(0)
    },
  },
  computed: {
    
  },
  methods: {
    toCategory(){
      window.location.href = "/client/category.jhtml"
    }
  }
}
</script>

<style scoped>
.classify-bar{
  width: 375px;
  display: flex;
  align-items: center
}
.category-line{
  width: 1px;
  height: 19px;
  background: url(/clientmodule/distVueCli/newHomeVue/img/new_home_line_icon.png) no-repeat;
  background-size: 100% 100%
}
.category-fixed{
  width: 41px;
  height: 27px;
  font-size: 15px;
  color: #666;
  background: url(/clientmodule/distVueCli/newHomeVue/img/new_home_classify_icon.png) no-repeat left 3px center;
  background-size: 15px 15px;
  padding-left: 20px;
  padding-top: 5px;
}
.classify{
  width: 313px;
  color: #333;
  font-size: 16px;
  /* position: fixed;
  top: 92px;
  left: 0; */
  height: 27px;
  /* padding-right: 15px; */
  padding-top: 5px;
  padding-bottom: 6px;
  z-index: 9;
}
.left-cover{
  position: absolute;
  top: 0;
  left: 0;
  width: 15px;
  height: 100%;
  z-index: 3;
  background: #fff
}
.classify-one{
  margin-left: 20px;
}
.van-tab img{
  height: 16px;
  position: relative;
  left: -10px;
}

</style>